import React from 'react'
import Create from '../crud/create'
import fields from './fields'
import menuItems from './menuItems'

const CreateCoreCurriculumWebinar = props => {
  return (
    <Create
      title='Add Core Curriculum Webinar'
      fields={fields}
      apiPath='admin/core_curriculum_webinars'
      successRedirectPath={resource => `/events/core-curriculum/${resource.id}/edit`}
      buildMenuItems={menuItems}
    />
  )
}

export default CreateCoreCurriculumWebinar
